// @ts-nocheck
import componentsReducer, { BunzlComponentsActions } from "@store/Framework/Store/Bunzl/Components/ComponentsReducer";
import pagesReducer, { BunzlPagesActions } from "@store/Framework/Store/Bunzl/Pages/PagesReducer";
import "@toolkit/Framework/Store";
import { useDispatch } from "react-redux";
import { combineReducers, Dispatch } from "redux";

export type BunzlActionUnion<T extends Record<string, (...args: any) => any>> = {
    [K in keyof T]: Parameters<T[K]>[1] extends undefined ? { type: K } : { type: K } & Parameters<T[K]>[1];
}[keyof T];
const bunzlReducers = {
    components: componentsReducer,
    pages: pagesReducer,
};

export type BunzlActions = BunzlComponentsActions | BunzlPagesActions;
export default combineReducers(bunzlReducers);

export const useBunzlDispatch = () => useDispatch<Dispatch<BunzlActions>>();
